const getters = {
  documentListUploaded(state) {
    return state.applicationSummary?.documentListUploaded;
  },
  referralCallbackUrl(state) {
    return state.applicationSummary?.referralCallbackUrl;
  },
  legalLanguage(state) {
    return state.legalLanguage || JSON.parse(localStorage.getItem('legalLanguage'));
  },
  nbfcName(state) {
    return state.nbfcName || JSON.parse(localStorage.getItem('nbfcName'));
  },
  businessInfo(state) {
    return state.applicationSummary?.businessInfo;
  },
  personalInfo(state) {
    return state.applicationSummary?.personalInfo;
  },
  isAndroidUser() {
    return typeof GenericEpaylater !== 'undefined';
  },
  fullName(state) {
    return `${state.applicationSummary?.personalInfo?.firstName || ''} ${state.applicationSummary?.personalInfo?.lastName || ''}`.trim();
  },
  supportId(state) {
    return state.supportId || localStorage.getItem('supportId');
  },
  welcomeRewardsData(state) {
    return state.welcomeRewardsData;
  },
  applicationSummary(state) {
    return state.applicationSummary;
  },
  isBusinessRegistrationDocUploaded(state) {
    return state.isBusinessRegistrationDocUploaded;
  },
  isBankStatementDocUploaded(state) {
    return state.isBankStatementDocUploaded;
  },
  applicationProfileData(state) {
    return state.applicationProfileData;
  }
};
export default getters;
